module.exports = __webpack_public_path__ + "img/logo.4dd2815a.png";